import parse from 'date-fns/parse'
import eachDayOfInterval from 'date-fns/eachDayOfInterval'
import differenceInDays from 'date-fns/differenceInDays'
import { DATE_FORMAT_WITHOUT_CONNECT, DATE_FORMAT } from './constant'
import { format } from 'date-fns'

// Data from hongkong official open data platform: https://data.gov.hk/en-data/dataset/hk-effo-statistic-cal
const oriHkHolidays = {
  vcalendar: [
    {
      prodid: '-//1823 Call Centre, Efficiency Office, HKSARG//Hong Kong Public Holidays//EN',
      version: '2.0',
      calscale: 'GREGORIAN',
      'x-wr-timezone': 'Asia/Hong_Kong',
      'x-wr-calname': '香港公众假期',
      'x-wr-caldesc': '香港公众假期',
      vevent: [
        {
          dtstart: ['20210101'],
          dtend: ['20210102'],
          transp: 'TRANSPARENT',
          uid: '20210101@1823.gov.hk',
          summary: '一月一日',
        },
        {
          dtstart: ['20210212'],
          dtend: ['20210213'],
          transp: 'TRANSPARENT',
          uid: '20210212@1823.gov.hk',
          summary: '农历年初一',
        },
        {
          dtstart: ['20210213'],
          dtend: ['20210214'],
          transp: 'TRANSPARENT',
          uid: '20210213@1823.gov.hk',
          summary: '农历年初二',
        },
        {
          dtstart: ['20210215'],
          dtend: ['20210216'],
          transp: 'TRANSPARENT',
          uid: '20210215@1823.gov.hk',
          summary: '农历年初四',
        },
        {
          dtstart: ['20210402'],
          dtend: ['20210403'],
          transp: 'TRANSPARENT',
          uid: '20210402@1823.gov.hk',
          summary: '耶稣受难节',
        },
        {
          dtstart: ['20210403'],
          dtend: ['20210404'],
          transp: 'TRANSPARENT',
          uid: '20210403@1823.gov.hk',
          summary: '耶稣受难节翌日',
        },
        {
          dtstart: ['20210405'],
          dtend: ['20210406'],
          transp: 'TRANSPARENT',
          uid: '20210405@1823.gov.hk',
          summary: '清明节翌日',
        },
        {
          dtstart: ['20210406'],
          dtend: ['20210407'],
          transp: 'TRANSPARENT',
          uid: '20210406@1823.gov.hk',
          summary: '复活节星期一翌日',
        },
        {
          dtstart: ['20210501'],
          dtend: ['20210502'],
          transp: 'TRANSPARENT',
          uid: '20210501@1823.gov.hk',
          summary: '劳动节',
        },
        {
          dtstart: ['20210519'],
          dtend: ['20210520'],
          transp: 'TRANSPARENT',
          uid: '20210519@1823.gov.hk',
          summary: '佛诞',
        },
        {
          dtstart: ['20210614'],
          dtend: ['20210615'],
          transp: 'TRANSPARENT',
          uid: '20210614@1823.gov.hk',
          summary: '端午节',
        },
        {
          dtstart: ['20210701'],
          dtend: ['20210702'],
          transp: 'TRANSPARENT',
          uid: '20210701@1823.gov.hk',
          summary: '香港特别行政区成立纪念日',
        },
        {
          dtstart: ['20210922'],
          dtend: ['20210923'],
          transp: 'TRANSPARENT',
          uid: '20210922@1823.gov.hk',
          summary: '中秋节翌日',
        },
        {
          dtstart: ['20211001'],
          dtend: ['20211002'],
          transp: 'TRANSPARENT',
          uid: '20211001@1823.gov.hk',
          summary: '国庆日',
        },
        {
          dtstart: ['20211014'],
          dtend: ['20211015'],
          transp: 'TRANSPARENT',
          uid: '20211014@1823.gov.hk',
          summary: '重阳节',
        },
        {
          dtstart: ['20211225'],
          dtend: ['20211226'],
          transp: 'TRANSPARENT',
          uid: '20211225@1823.gov.hk',
          summary: '圣诞节',
        },
        {
          dtstart: ['20211227'],
          dtend: ['20211228'],
          transp: 'TRANSPARENT',
          uid: '20211227@1823.gov.hk',
          summary: '圣诞节后第一个周日',
        },
        {
          dtstart: ['20220101'],
          dtend: ['20220102'],
          transp: 'TRANSPARENT',
          uid: '20220101@1823.gov.hk',
          summary: '一月一日',
        },
        {
          dtstart: ['20220201'],
          dtend: ['20220202'],
          transp: 'TRANSPARENT',
          uid: '20220201@1823.gov.hk',
          summary: '农历年初一',
        },
        {
          dtstart: ['20220202'],
          dtend: ['20220203'],
          transp: 'TRANSPARENT',
          uid: '20220202@1823.gov.hk',
          summary: '农历年初二',
        },
        {
          dtstart: ['20220203'],
          dtend: ['20220204'],
          transp: 'TRANSPARENT',
          uid: '20220203@1823.gov.hk',
          summary: '农历年初三',
        },
        {
          dtstart: ['20220405'],
          dtend: ['20220406'],
          transp: 'TRANSPARENT',
          uid: '20220405@1823.gov.hk',
          summary: '清明节',
        },
        {
          dtstart: ['20220415'],
          dtend: ['20220416'],
          transp: 'TRANSPARENT',
          uid: '20220415@1823.gov.hk',
          summary: '耶稣受难节',
        },
        {
          dtstart: ['20220416'],
          dtend: ['20220417'],
          transp: 'TRANSPARENT',
          uid: '20220416@1823.gov.hk',
          summary: '耶稣受难节翌日',
        },
        {
          dtstart: ['20220418'],
          dtend: ['20220419'],
          transp: 'TRANSPARENT',
          uid: '20220418@1823.gov.hk',
          summary: '复活节星期一',
        },
        {
          dtstart: ['20220502'],
          dtend: ['20220503'],
          transp: 'TRANSPARENT',
          uid: '20220502@1823.gov.hk',
          summary: '劳动节翌日',
        },
        {
          dtstart: ['20220509'],
          dtend: ['20220510'],
          transp: 'TRANSPARENT',
          uid: '20220509@1823.gov.hk',
          summary: '佛诞翌日',
        },
        {
          dtstart: ['20220603'],
          dtend: ['20220604'],
          transp: 'TRANSPARENT',
          uid: '20220603@1823.gov.hk',
          summary: '端午节',
        },
        {
          dtstart: ['20220701'],
          dtend: ['20220702'],
          transp: 'TRANSPARENT',
          uid: '20220701@1823.gov.hk',
          summary: '香港特别行政区成立纪念日',
        },
        {
          dtstart: ['20220912'],
          dtend: ['20220913'],
          transp: 'TRANSPARENT',
          uid: '20220912@1823.gov.hk',
          summary: '中秋节后第二日',
        },
        {
          dtstart: ['20221001'],
          dtend: ['20221002'],
          transp: 'TRANSPARENT',
          uid: '20221001@1823.gov.hk',
          summary: '国庆节',
        },
        {
          dtstart: ['20221004'],
          dtend: ['20221005'],
          transp: 'TRANSPARENT',
          uid: '20221004@1823.gov.hk',
          summary: '重阳节',
        },
        {
          dtstart: ['20221226'],
          dtend: ['20221227'],
          transp: 'TRANSPARENT',
          uid: '20221226@1823.gov.hk',
          summary: '圣诞节后第一个周日',
        },
        {
          dtstart: ['20221227'],
          dtend: ['20221228'],
          transp: 'TRANSPARENT',
          uid: '20221227@1823.gov.hk',
          summary: '圣诞节后第二个周日',
        },
        {
          dtstart: ['20230102'],
          dtend: ['20230103'],
          transp: 'TRANSPARENT',
          uid: '20230102@1823.gov.hk',
          summary: '一月一日翌日',
        },
        {
          dtstart: ['20230123'],
          dtend: ['20230124'],
          transp: 'TRANSPARENT',
          uid: '20230123@1823.gov.hk',
          summary: '农历年初二',
        },
        {
          dtstart: ['20230124'],
          dtend: ['20230125'],
          transp: 'TRANSPARENT',
          uid: '20230124@1823.gov.hk',
          summary: '农历年初三',
        },
        {
          dtstart: ['20230125'],
          dtend: ['20230126'],
          transp: 'TRANSPARENT',
          uid: '20230125@1823.gov.hk',
          summary: '农历年初四',
        },
        {
          dtstart: ['20230405'],
          dtend: ['20230406'],
          transp: 'TRANSPARENT',
          uid: '20230405@1823.gov.hk',
          summary: '清明节',
        },
        {
          dtstart: ['20230407'],
          dtend: ['20230408'],
          transp: 'TRANSPARENT',
          uid: '20230407@1823.gov.hk',
          summary: '耶稣受难节',
        },
        {
          dtstart: ['20230408'],
          dtend: ['20230409'],
          transp: 'TRANSPARENT',
          uid: '20230408@1823.gov.hk',
          summary: '耶稣受难节翌日',
        },
        {
          dtstart: ['20230410'],
          dtend: ['20230411'],
          transp: 'TRANSPARENT',
          uid: '20230410@1823.gov.hk',
          summary: '复活节星期一',
        },
        {
          dtstart: ['20230501'],
          dtend: ['20230502'],
          transp: 'TRANSPARENT',
          uid: '20230501@1823.gov.hk',
          summary: '劳动节',
        },
        {
          dtstart: ['20230526'],
          dtend: ['20230527'],
          transp: 'TRANSPARENT',
          uid: '20230526@1823.gov.hk',
          summary: '佛诞',
        },
        {
          dtstart: ['20230622'],
          dtend: ['20230623'],
          transp: 'TRANSPARENT',
          uid: '20230622@1823.gov.hk',
          summary: '端午节',
        },
        {
          dtstart: ['20230701'],
          dtend: ['20230702'],
          transp: 'TRANSPARENT',
          uid: '20230701@1823.gov.hk',
          summary: '香港特别行政区成立纪念日',
        },
        {
          dtstart: ['20230930'],
          dtend: ['20231001'],
          transp: 'TRANSPARENT',
          uid: '20230930@1823.gov.hk',
          summary: '中秋节翌日',
        },
        {
          dtstart: ['20231002'],
          dtend: ['20231003'],
          transp: 'TRANSPARENT',
          uid: '20231002@1823.gov.hk',
          summary: '国庆节翌日',
        },
        {
          dtstart: ['20231023'],
          dtend: ['20231024'],
          transp: 'TRANSPARENT',
          uid: '20231023@1823.gov.hk',
          summary: '重阳节',
        },
        {
          dtstart: ['20231225'],
          dtend: ['20231226'],
          transp: 'TRANSPARENT',
          uid: '20231225@1823.gov.hk',
          summary: '圣诞节',
        },
        {
          dtstart: ['20231226'],
          dtend: ['20231227'],
          transp: 'TRANSPARENT',
          uid: '20231226@1823.gov.hk',
          summary: '圣诞节后第一个周日',
        },
      ],
    },
  ],
}
const getFormatHolidays = () => {
  let holidayList = []
  const oriHolidayList = oriHkHolidays.vcalendar[0].vevent
  oriHolidayList.forEach((holiday) => {
    const startDate = parse(holiday.dtstart[0], DATE_FORMAT_WITHOUT_CONNECT, new Date())
    const endDate = parse(holiday.dtend[0], DATE_FORMAT_WITHOUT_CONNECT, new Date())
    if (differenceInDays(endDate, startDate) <= 1) {
      holidayList.push(format(startDate, DATE_FORMAT))
    } else {
      holidayList.concat(
        eachDayOfInterval(
          parse(startDate, DATE_FORMAT_WITHOUT_CONNECT, new Date()),
          parse(startDate, DATE_FORMAT_WITHOUT_CONNECT, new Date()),
        ).map((day) => format(day, DATE_FORMAT)),
      )
    }
  })
  return holidayList
}
export const HK_HOLIDAYS = getFormatHolidays()
